import axios from 'axios'

import { handleRequestError } from './request'

export const REQUEST_SUBSCRIPTION_PAYMENTS = 'REQUEST_SUBSCRIPTION_PAYMENTS'
export const RECEIVE_SUBSCRIPTION_PAYMENTS = 'RECEIVE_SUBSCRIPTION_PAYMENTS'

export const requestSubscriptionPayments = (data) => (dispatch) => {
    dispatch({ type: REQUEST_SUBSCRIPTION_PAYMENTS, data })

    const { subscriptionId } = data

    return axios
        .get(`/subscriptions/${subscriptionId}/payments`)
        .then((response) => {
            const payments = response.data
            dispatch(receiveSubscriptionPayments({ payments, subscriptionId }))

            return response.data
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

const receiveSubscriptionPayments = (data) => ({ type: RECEIVE_SUBSCRIPTION_PAYMENTS, data })
